import ModalVideo from "modal-video";
new ModalVideo('._js-modal-btn');